// mission-workspace-hooks.ts
//
// Tách THUẦN từ mission-workspace.ts (phase 10, lô A): dựng `settings.hooks`
// cho mission workspace từ allowlist `AUTOPILOT_REQUIRED_HOOK_FILES`.

import { join } from "node:path";
import { pathExists } from "../filesystem-helpers.js";
import { AUTOPILOT_REQUIRED_HOOK_FILES, type MissionHooks } from "./mission-settings-profile.js";

/**
 * Khối `settings.hooks` cho mission, dựng từ allowlist trên.
 *
 * Path dùng `${CLAUDE_PROJECT_DIR}` + `.claude/pack/...` — TUYỆT ĐỐI (bất biến
 * đã có: Bash `cd` làm lệch CWD nên relative path sẽ hỏng), và trỏ thẳng vào
 * pack ĐÃ GHIM trong mission thay vì symlink farm, để hook không đổi theo
 * `avatar sync` giữa chừng mission.
 *
 * `matcher: "PreToolUse"` khai cả Edit-family lẫn Bash: dangerous-guard tự lọc
 * non-Bash (exit 0), WHW tự lọc tool ngoài ENFORCED_TOOLS — nên một matcher
 * chung là đủ và không cần giữ 2 danh sách song song.
 *
 * ⚠️ CHỈ khai hook có file THẬT trong pack đã ghim.
 *
 * Bản đầu của fix F4 khai cả hai hook vô điều kiện và ĐÃ LÀM HỎNG đường chạy
 * thật: `checkHookCommandsExist` (có sẵn từ trước) từ chối mọi command trỏ tới
 * file không tồn tại, nên mission nào có pack thiếu 1 trong 2 hook đều
 * `hook_command_file_missing` rồi blocked — đo được trên 10 e2e file VÀ probe
 * `honest`, vốn là ca ĐỐI CHỨNG phải xanh. WHW là tool TẮT ĐƯỢC
 * (`avatar tools disable why-how-what-confirm`) nên pack hợp lệ có quyền không
 * mang nó; khai hook cho file vắng mặt là tự dựng cổng chặn chính mình.
 */
export async function buildMissionHooks(packDir: string): Promise<MissionHooks> {
  const hooks: Array<{ type: string; command: string }> = [];
  for (const relPath of AUTOPILOT_REQUIRED_HOOK_FILES) {
    if (!(await pathExists(join(packDir, relPath)))) continue;
    // `-B` (dogfood 2026-09-15, mission ME-2026-11ce3c): the hooks import
    // `scripts/autopilot_binding_common.py`, and python's default import
    // writes `scripts/__pycache__/*.pyc` INTO the pinned pack on the first
    // PreToolUse of every attempt. That file is untracked in the worktree, so
    // the verifier's inventory diff attributed it to the worker —
    // `changed_files vượt allowed_paths` on 3/3 attempts of the first ticket,
    // mission blocked before any product code ran. The controller must not
    // leave its own artifacts for its own scope check to find; refusing to
    // write bytecode is narrower than teaching the verifier to ignore it
    // (a tampered `.pyc` is exactly what that check should still see).
    hooks.push({
      type: "command",
      command: `python3 -B \${CLAUDE_PROJECT_DIR}/.claude/pack/${relPath}`,
    });
  }
  return hooks.length > 0 ? { PreToolUse: [{ hooks }] } : {};
}
